export const nirf=[
    {
        'id':'7',
        'program':'NIRF 2026 Engineering',
        'pdf':'https://drive.google.com/file/d/13ztaN33d0_hlAK6Ntn0-hBbj3OIMGPq2/view?usp=sharing'
    },

    {
        'id':'6',
        'program':'NIRF 2025 Engineering',
        'pdf':'https://drive.google.com/file/d/1lzjsVBOvfUMum8yqM1ZsCYJ6KtVHqf0t/view?usp=sharing'
    },
    {
        'id':'5',
        'program':'NIRF 2024 Innovation',
        'pdf':'https://drive.google.com/file/d/1wVcvUtBVo69lSiso-TyRU_TBwIEVUWnS/view?usp=sharing'
    },
    {
        'id':'6',
        'program':'NIRF 2024 Engineering',
        'pdf':'https://drive.google.com/file/d/1tclI4_ZHeJFalkcJ6FYsNJYDSfqlqt_O/view?usp=sharing'
    },
        {
            'id':'1',
            'program':'NIRF Innovation Rank',
            'pdf':'https://drive.google.com/file/d/1Os9Tk1Xs_KZabwrEpWgt9nSTHkrM8Kw5/view?usp=sharing'
        },
        {
            'id':'2',
            'program':'NIRF Innovation Certificate',
            'pdf':'https://drive.google.com/file/d/1vDp11tPzfPrei_vqm4RusuuxBobS10jw/view?usp=sharing'
        },
        {
            'id':'4',
            'program':'NIRF-2023',
            'pdf':'https://drive.google.com/file/d/1Bk1ZeYkZNCqtrINlxjpoSNq4EL3y9Nvd/view?usp=sharing'
        },
        {
            'id':'3',
            'program':'NIRF-2022',
            'pdf':'https://drive.google.com/file/d/1E1WT5zTR4iWcUbO8vx36zmPXGerB3ayv/view?usp=sharing'
        },
        {
            'id':'5',
            'program':'NIRF-2021',
            'pdf':'https://drive.google.com/file/d/1-DdofEfKjhRdTFNcbrYHbHP7LtdCOcek/view?usp=drive_link'
        },
    ]
